import { useEffect, useState } from "react";
import Quartiles from "../model/Quartiles";
import { ecsN } from "../utils/utils";

export function Score(props: {
  score: number;
  quartiles: Quartiles;
  isGlobal: boolean;
  category: string;
}) {
  const n = ecsN(props.score, props.quartiles, props.isGlobal, props.category);
  const letters = ["A", "B", "C", "D", "E", "F"];

  function style(index: number) {
    if (n === -1) {
      return "w-8 h-8 sm:w-10 sm:h-10";
    }
    if (index === n) {
      return "w-16 h-16 sm:w-32 sm:h-32 xl:w-24 xl:h-24 2xl:w-32 2xl:h-32 text-xl sm:text-3xl font-semibold";
    } else if (index === n - 1 || index === n + 1) {
      return "w-12 h-12 sm:w-20 sm:h-20 xl:w-14 xl:h-14 2xl:w-20 2xl:h-20 opacity-50 text-lg font-medium";
    } else if (index === n - 2 || index === n + 2) {
      return "w-10 h-10 sm:w-16 sm:h-16 xl:w-12 xl:h-12 2xl:w-16 2xl:h-16 opacity-50 text-lg font-medium";
    } else if (index === n - 3 || index === n + 3) {
      return "w-8 h-8 sm:w-14 sm:h-14 xl:w-10 xl:h-10 2xl:w-14 2xl:h-14 opacity-50 text-lg font-medium";
    } else if (index === n - 4 || index === n + 4) {
      return "w-6 h-6 sm:w-12 sm:h-12 xl:w-8 xl:h-8 2xl:w-12 2xl:h-12 opacity-50 text-lg font-medium";
    } else if (index === n - 5 || index === n + 5) {
      return "w-4 h-4 sm:w-10 sm:h-10 xl:w-6 xl:h-6 2xl:w-10 2xl:h-10 opacity-50 text-lg font-medium";
    }
  }

  const [correctQuartiles, setCorrectQuartiles] = useState<number[]>([]);

  useEffect(() => {
    if (props.isGlobal) {
      setCorrectQuartiles(props.quartiles.global_quartiles);
    } else {
      setCorrectQuartiles(
        props.quartiles.sub_category_quartiles[props.category]
      );
    }
  }, [props.isGlobal, props.quartiles, props.category]);

  return (
    <div className="flex gap-0.3 items-center justify-center md:justify-start">
      {letters.map((letter, index) => {
        return (
          <div key={index} className="group relative">
            <div
              className={
                "flex flex-col items-center justify-center rounded-full z-10 bg-score" +
                (index + 1).toString() +
                " " +
                style(index)
              }
            >
              <p className="text-white">{letter}</p>
              {index === n && (
                <div className="flex items-center text-white">
                  <p className="text-xs sm:text-base xl:text-sm 2xl:text-base font-medium">
                    {Math.round(props.score)}
                  </p>
                  <p className="text-xs font-light">Pt</p>
                </div>
              )}
            </div>
            <div className="absolute hidden group-hover:block bg-white dark:bg-black text-white dark:text-black text-xs rounded-xl bottom-[-36px] font-normal text-center translate-x-[-10%]">
              <div className="w-full h-full p-2 rounded-xl bg-blackLight dark:bg-whiteLight">
                <p className="whitespace-nowrap">
                  {correctQuartiles !== undefined &&
                    correctQuartiles.length === 7 &&
                    Math.round(correctQuartiles[index] ?? 0) +
                      "Pt - " +
                      Math.round(correctQuartiles[index + 1] ?? 0) +
                      "Pt"}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
